




















































































import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { courseItem, resourceItem } from '@/api/res'
import { fetchInstallStatus } from './data'
import { post, get } from '@/fn/ajax'
import { Tooltip, Modal, message } from 'ant-design-vue'

@Component({
  components: {}
})
export default class PlayInstall extends ViewBase {
  @Prop({ default: 0 }) id!: any

  percent: number = 20

  lang: any = {}

  refresh: boolean = false

  installList: any = {
    installedList: [],
    installingList: [],
    uninstalledList: [],
    failedList: []
  }

  loading: boolean = true

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  getInstallList() {
    this.refresh = false
    fetchInstallStatus(this.id).then((res: any) => {
      this.installList = res
      this.refresh = true
      this.loading = false
    })
  }
  async reinstall(list: any) {
    const ids: any = []
    list.forEach((item: any) => {
      ids.push(item.id)
    })
    const pdata = {
      rids: this.id,
      ids
    }
    try {
      await post('/api/play/send_resource', pdata)
      this.getInstallList()
      message.success(this.i18n.uHeader.operationSuccess)
    } catch (ex) {
      message.error(String(ex))
    }
  }
  created() {
    this.loading = true
    this.getInstallList()
  }
  @Watch('id')
  watchId(value: any) {
    this.getInstallList()
  }
  @Watch('refresh')
  watchRefresh(refresh: boolean) {
    if (refresh) {
      setTimeout(() => {
        this.getInstallList()
      }, 3000)
    }
  }
}
